
export const colorChargeCodeBackgroundDefault = ``;
